import api from "../../../_metronic/helpers/api";
import {stringify} from "qs";

function useUtils() {

  const fetchDashboard = async (startDate, endDate) => {
    try {
         const params = {
            startDate,
            endDate
        }
      const response = await api.get(`/dashboard/statistics?${stringify(params)}`);
      if (response.data.status) {
        return response.data.data
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchVideos = async()=>{
    try {
      const response = await api.get(`/video/get/trending`)
      if (response.data.status==='success') {
        return response.data.data
      }
    } catch (error) {
      
    }
  }

  return {
    fetchDashboard,
    fetchVideos
  };
}

export default useUtils;
